import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { delay, put, select, takeEvery } from "redux-saga/effects";
import axios from "../../../Utils/axiosConfig";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { VerifyOtpFormTypes } from "../../../Components/Authentication/VerifyOtpForm/VerifyOtpForm";
import { closeModal, openModal } from "../modal/modal";
import { setIsLogin } from "./checkLoginSlice";
import { alert } from "../../../Utils/toast";
import { checkLoginActions } from "./checkLogin";
import { toEnglishDigits } from "../../../Utils/toEnglishDigits";
import { queryClient } from "../../store";
import { getCurrentLanguage } from "../../../Utils/sagaHelpers";
import { ModalNames } from "../../../Constants/modalNames";
import Cookies from "js-cookie";

export type VerifyOtpLoadAction = {
  type: string;
  payload: VerifyOtpFormTypes;
};

export type VerifyOtpData = {
  data: any;
};

const VerifyOtp = new ReduxFetchState<VerifyOtpData, VerifyOtpFormTypes, any>("verifyOtp");

export function* watchVerifyOtp(action: VerifyOtpLoadAction) {
  const formData = new FormData();
  formData.append("username", action.payload?.username);
  formData.append("code", toEnglishDigits(action.payload?.code));

  const lang: "fa" | "en" = yield getCurrentLanguage();

  try {
    const data: VerifyOtpData = yield axios({
      headers: { "Content-Type": "multipart/form-data" },
      url: "/api/v1/users/otp-verify",
      method: "POST",
      data: formData,
    });

    yield put(VerifyOtp.actions.loadSuccess(data));
    action.payload.afterLoginAction && action.payload.afterLoginAction();
    yield put(setIsLogin(true));
    yield put(checkLoginActions.load());
    yield put(closeModal());
    alert({ message: data?.data?.message, type: "success" });

    queryClient.removeQueries({ queryKey: ["checkLogin", lang] });
    queryClient.removeQueries({ queryKey: ["getProfile", lang] });
    queryClient.removeQueries({ queryKey: ["getSubscriptionPlans", lang] });
    queryClient.removeQueries({ queryKey: ["getAnnouncedNotifications", lang] });

    const params = new URLSearchParams(window.location.search);
    const retryChat = params.get("retryChat");
    const recentlyCreated: string = yield select((state) => state?.referralCode?.recentlyCreated);
    if (recentlyCreated) {
      yield delay(500);
      yield put(openModal({ name: ModalNames.ReferralCodeModal }));
    } else {
      if (retryChat !== "true"){
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(VerifyOtp.actions.loadFailure(e.message));
  }
}

export function* verifyOtpSagas() {
  yield takeEvery(VerifyOtp.actionTypes.load, watchVerifyOtp);
}

export function useVerifyOtp() {
  const { loading, data, ...verifyOtpState } = useAppSelector((state) => state.verifyOtp);
  const dispatch = useAppDispatch();

  const dispatchVerifyOtp = useCallback(
    (data: VerifyOtpFormTypes) => {
      dispatch(VerifyOtp.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...verifyOtpState,
    dispatchVerifyOtp,
    verifyOtpLoading: loading,
    verifyOtpData: data,
  };
}

export const {
  actionTypes: verifyOtpActionsTypes,
  actions: verifyOtpActions,
  reducer: verifyOtpReducer,
} = VerifyOtp;
